import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutReportScheduleList extends Layout {
    buttonScheduleNow: Button;
    layoutheaderTitle: LayoutHeader;
    sourceReportScheduleList: DataSource;
    tableList: Table;
}
